export const engagementLinkTemplatesSelect = "/engagement/link_templates/select";
